import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { showErrorToast } from '../../../components/atoms/Utlis/Toast';
import { createOrderAPI, getAllOrdersAPI } from '../../ApiCalls/Dashboard/OrderAPI';
import { OrderState } from '../../Slice/Dashboard/OrderSlice';

export const OrderReducer = (builder: ActionReducerMapBuilder<OrderState>) => {
    builder
        .addCase(createOrderAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(createOrderAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
        })
        .addCase(createOrderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && (action.payload as any).message) {
                showErrorToast((action.payload as any).message);
            } else {
                console.log(action.payload);
            }
        })
        .addCase(getAllOrdersAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(getAllOrdersAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.allOrders = action.payload?.results || action.payload || [];
            state.totalCount = action.payload?.count || (action.payload?.results ? action.payload.results.length : action.payload?.length) || 0;
        })
        .addCase(getAllOrdersAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && (action.payload as any).message) {
                showErrorToast((action.payload as any).message);
            }
        });
};
